import {
  useConnectionActionPermissions,
  useCurrentUser,
  useIsManagedConnectionsEntitled,
} from "@zapier/client";

/**
 * Whether the user can create managed connections (admin+ on an account with
 * the managed connections entitlement). `isLoading` is true until the user and
 * entitlements have loaded.
 */
export function useCanCreateManagedConnection() {
  const { canCreateManagedConnection: canByRole } =
    useConnectionActionPermissions({});
  const { isManagedConnectionsEntitled, isLoading: isEntitlementLoading } =
    useIsManagedConnectionsEntitled();
  const { isLoading: isUserLoading } = useCurrentUser();

  return {
    canCreateManagedConnection: canByRole && isManagedConnectionsEntitled,
    isLoading: isUserLoading || isEntitlementLoading,
  };
}
